import { render } from "./PortraitManagement.vue?vue&type=template&id=499c096f&scoped=true"
import script from "./PortraitManagement.vue?vue&type=script&lang=js"
export * from "./PortraitManagement.vue?vue&type=script&lang=js"

import "./PortraitManagement.vue?vue&type=style&index=0&id=499c096f&scoped=true&lang=scss"
import "./PortraitManagement.vue?vue&type=style&index=1&id=499c096f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499c096f"]])

export default __exports__